import * as React from 'react';
import { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import { EditHardware, getUser } from '../../services/service'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { getAllCompanyValue, getAllHardwareModels } from '../../services/service';
import { MenuItem } from '@mui/material';
import { APITextField } from '../APITextField';
import { APISelectField } from '../APISelectField';
import { FormDialog } from '../../components/FormDialog';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};



const validationSchema = Yup.object({
  company: Yup.string()
    .required('Necessário escolher a quantidade!'),
  hardware_model: Yup.string()
    .required('Necessário escolher a quantidade!'),
  hardware_key: Yup.string()
    .required('Necessário escolher a quantidade!'),
})


export default function EditHardwareModelModal(props) {
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const { hardwareModel, onHardwareEdited, open, setOpen } = props

  // Instancia um formik, passando os valores iniciais como sendo os valores do hardwareModel
  // E também qual a lógica que será utilizada quando o mesmo for submetido (onSubmit)
  // Que no caso, é a requisição PUT para editar os hardwares.
  // Quando a requisição for bem sucedida, chamamos a função onHardwareModelEdited,
  // que é fornecida pelo parente que criou este componente

  const parseValue = (hwModel) => {
    var newModel = hwModel
    newModel["hardware_model"] = hwModel["hardware_model_id"]
    newModel["company"] = hwModel["company_id"]
    return newModel
  }
  const formik = useFormik({
    initialValues: parseValue(hardwareModel),
    validationSchema: validationSchema,

    onSubmit: (values) => {
      const putData = {
        'company': formik.values.company,
        'hardware_model': formik.values.hardware_model,
        'hardware_key': formik.values.hardware_key,
        'name': formik.values.name,
        'description': formik.values.description,
      }
      setLoading(true)
      const id = hardwareModel['id']
      EditHardware(id, putData).then((response) => {
        onHardwareEdited(response.data)
      }).catch(err => {
        setErrors(err.response.data);
      })
        .finally((resp) => {
          setLoading(false)
        })

    },
  })


  const handleClose = () => {
    setOpen(false);
  };


  const [allCompany, setAllcompany] = useState([])
  const [allHardwareModels, setAllHardwareModels] = useState([])


  useEffect(() => {
    getAllCompanyValue().then((resp) => {
      setAllcompany(resp.data.results)
    }).catch((err) => {
        if(err.response.status===403){
          getUser().then((resp)=>{
            setAllcompany([resp.data.company])
          })
        }
    })
  }, [getAllCompanyValue])

  useEffect(() => {
    getAllHardwareModels().then((resp) => setAllHardwareModels(resp.data.results))
  }, [getAllHardwareModels])


  return (
    <Box sx={style}>
      <FormDialog
        title={"Editar Hardware"}
        open={open}
        onDismiss={handleClose}
        formWidth={500}
        loading={loading}
        onSubmit={formik.handleSubmit}
      >
        <APISelectField
          name="company"
          label={"Empresa"}
          value={formik.values.company}
          onChange={formik.handleChange}
          errors={errors?.company}
          variant={"standard"}
        >
          {allCompany.map((companyValue, idx) => (
            <MenuItem key={idx} value={companyValue.id}>
              {companyValue.name}
            </MenuItem>
          ))}

        </APISelectField>
        <APISelectField
          name="hardware_model"
          value={formik.values.hardware_model}
          errors={errors?.hardware_model}
          variant={"standard"}
          label={"Modelo do Hardware"}
          onChange={formik.handleChange}
        >
          {allHardwareModels.map((hwModel, idx) => (
            <MenuItem key={idx} value={hwModel.id}>
              {hwModel.model}
            </MenuItem>
          ))}

        </APISelectField>
        <APITextField
          id="hardware_key"
          name="hardware_key"
          label="Chave do hardware"
          disabled={loading}
          value={formik.values.hardware_key}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.hardware_key}
        />
        <APITextField
          id="hardware-name"
          name="name"
          label="Nome do hardware "
          disabled={loading}
          value={formik.values.name}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.name}
        />
        <APITextField
          id="description"
          label="Descrição do hardware "
          disabled={loading}
          value={formik.values.description}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.description}
        />
      </FormDialog>
    </Box >
  );
}